import { render, staticRenderFns } from "./ReleaseEmailView.vue?vue&type=template&id=78004eaa&scoped=true"
import script from "./ReleaseEmailView.vue?vue&type=script&lang=js"
export * from "./ReleaseEmailView.vue?vue&type=script&lang=js"
import style0 from "./ReleaseEmailView.vue?vue&type=style&index=0&id=78004eaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78004eaa",
  null
  
)

export default component.exports